import React, { useState, useMemo } from 'react';
import { Container, Row, Col, Card, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  FaArrowLeft,
  FaTrophy,
  FaHeart,
  FaFacebook,
  FaWhatsapp,
  FaInstagram,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaQuoteRight,
  FaAward,
  FaSearch,
  FaStar
} from 'react-icons/fa';
import awardImage from '../../images/pichaAwad.WEBP';
import picha1 from '../../images/picha1.WEBP';
import picha2 from '../../images/picha2.WEBP';
import picha4 from '../../images/picha4.WEBP';
import picha5 from '../../images/picha5.WEBP';
import './Awards.css';

const Awards = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Gallery images data
  const galleryImages = useMemo(() => [
    {
      id: 1,
      src: awardImage,
      title: "Certificate of Appreciation",
      description: "Cheti cha uthamini cha Harusi Online",
      category: "Certificate"
    },
    {
      id: 2,
      src: picha1,
      title: "Timu Yetu Inashangilia",
      description: "Wafanyakazi wakishangilia ushindi wa tuzo",
      category: "Celebration"
    },
    {
      id: 3,
      src: picha2,
      title: "Mkono wa Ushindi",
      description: "Kupokea tuzo kwa furaha na heshima",
      category: "Award Ceremony"
    },
    {
      id: 4,
      src: picha4,
      title: "Furaha ya Ushindi",
      description: "Mfanyakazi akishikilia tuzo kwa furaha",
      category: "Celebration"
    },
    {
      id: 5,
      src: picha5,
      title: "Wakati wa Kukumbukwa",
      description: "Picha ya pamoja wakati wa tuzo",
      category: "Group Photo"
    }
  ], []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const openModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  return (
    <div className="awards-page">
      <Container className="py-5 mt-5">
        

        {/* Hero Section */}
        <div className="awards-hero">
          <div className="awards-hero-content">
            <div className="awards-badge">
              <FaTrophy className="awards-badge-icon" />
              <span>#HarusiAwards 2022</span>
            </div>
            <h1 className="awards-title">
              Best Wedding Innovative
              <span className="awards-title-highlight">Best Digital Events Management Platform</span>
            </h1>
            <p className="awards-description">
              Tuzo hii ni ya kila mmoja wetu. Asante kwa kuwa sehemu ya safari hii ya kipekee.
            </p>
            <div className="awards-stats">
              <div className="awards-stat">
                <span className="awards-stat-number">2022</span>
                <span className="awards-stat-label">Mwaka Wa Tuzo</span>
              </div>
              <div className="awards-stat">
                <span className="awards-stat-number">#1</span>
                <span className="awards-stat-label">Digital Platform</span>
              </div>
              <div className="awards-stat">
                <span className="awards-stat-number">100%</span>
                <span className="awards-stat-label">Ubunifu na Uaminifu</span>
              </div>
            </div>
          </div>
        </div>

        {/* Certificate & Message Section */}
        <Row className="mt-5 g-4">
          <Col lg={6}>
            <Card className="awards-certificate-card">
              <div className="certificate-image-wrapper">
                <img
                  src={picha1}
                  alt="Harusi Online Certificate of Appreciation"
                  className="certificate-image"
                />
                <div className="certificate-overlay">
                  <button
                    className="certificate-view-btn"
                    onClick={() => openModal({ src: picha1, title: "Certificate of Appreciation" })}
                  >
                    <FaSearch /> Tazama
                  </button>
                </div>
              </div>
              <Card.Body className="certificate-body">
                <div className="certificate-badge">
                  <FaAward className="certificate-badge-icon" />
                  <span>Cheti cha Uthamini</span>
                </div>
                <h3 className="certificate-title">Certificate of Appreciation</h3>
                <p className="certificate-description">
                  Tunashukuru kwa kutambuliwa kama kampuni bora ya ubunifu katika sekta ya harusi na matukio mwaka 2022.
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <div className="awards-message">
              <div className="awards-message-icon">
                <FaQuoteRight />
              </div>
              <h3 className="awards-message-title">Ushindi Wetu Sote!</h3>
              <p className="awards-message-text">
                Harusionline, shughuli kiganjani mwako.. Certificate of Appreciation!
                Tunawashukuru wateja, marafiki na wadau wetu wote kwa support ya nguvu.
                Ushindi huu ni wa kila aliyetumia na kuamini mfumo wetu.
              </p>
              <div className="awards-message-footer">
                <div className="awards-message-author">
                  <div className="awards-message-avatar">
                    <FaHeart />
                  </div>
                  <div>
                    <h6 className="mb-0">Timu ya Harusi Online</h6>
                    <small className="text-muted">Tuzo 2022</small>
                  </div>
                </div>
                <div className="awards-message-share">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="share-btn facebook" aria-label="Facebook"><FaFacebook /></a>
                  <a href="https://wa.me" target="_blank" rel="noopener noreferrer" className="share-btn whatsapp" aria-label="WhatsApp"><FaWhatsapp /></a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="share-btn instagram" aria-label="Instagram"><FaInstagram /></a>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Gallery Section */}
        <div className="awards-gallery mt-5">
          <div className="gallery-header">
            <div>
              <span className="gallery-subtitle">Picha Zetu</span>
              <h2 className="gallery-title">Kumbukumbu za Ushindi</h2>
            </div>
            <div className="gallery-nav">
              <button className="gallery-nav-btn" onClick={prevSlide} aria-label="Previous">
                <FaChevronLeft />
              </button>
              <span className="gallery-counter">
                {currentSlide + 1} / {galleryImages.length}
              </span>
              <button className="gallery-nav-btn" onClick={nextSlide} aria-label="Next">
                <FaChevronRight />
              </button>
            </div>
          </div>

          <div className="gallery-grid">
            {galleryImages.map((img, idx) => (
              <div
                key={img.id}
                className={`gallery-item ${currentSlide === idx ? 'active' : ''}`}
                onClick={() => openModal(img)}
              >
                <img src={img.src} alt={img.title} className="gallery-image" />
                <div className="gallery-item-overlay">
                  <div className="gallery-item-content">
                    <FaSearch className="gallery-item-icon" />
                    <span className="gallery-item-text">{img.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="gallery-thumbnails mt-3">
            {galleryImages.map((img, idx) => (
              <button
                key={img.id}
                className={`thumbnail-btn ${currentSlide === idx ? 'active' : ''}`}
                onClick={() => setCurrentSlide(idx)}
              >
                <img src={img.src} alt={img.title} className="thumbnail-image" />
              </button>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="awards-cta mt-5">
          <div className="awards-cta-content">
            <h2 className="awards-cta-title">Tayari Kuanza Safari Yako Nasi?</h2>
            <p className="awards-cta-text">
              Jiunge na maelfu ya wateja wanaotumia Harusi Online kurahisisha na kufanikisha shughuli zao.
            </p>
            <Link to="/login" className="awards-cta-btn">
              Anza Sasa
            </Link>
          </div>
        </div>
      </Container>

      {/* Lightbox Modal */}
      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        size="xl"
        className="awards-modal"
      >
        <Modal.Body className="text-center p-0">
          {selectedImage && (
            <div className="position-relative d-inline-block m-auto">
              <button
                type="button"
                className="modal-close-btn"
                onClick={closeModal}
                aria-label="Close"
              >
                <FaTimes />
              </button>
              <img
                src={selectedImage.src || selectedImage}
                alt={selectedImage.title || "Preview"}
                className="modal-image"
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Awards;
